import { Chip } from '@nespresso-design-system/components';
import type { Translations } from '@/widgets/ProductList/config';
import type { FiltersAndSort } from '@/widgets/services/FilteringAndSortingService';
import useTranslations from '@/widgets/hooks/useTranslations';
import styles from '../AllFiltersDrawer.module.scss';
import type { SortOption } from '@/domain/FilteringAndSorting';

type SortingProps = {
  sorting: FiltersAndSort['sorting'];
};

export function SortingList({ sorting }: SortingProps) {
  return (
    <ul class={styles.container}>
      <li key={`recommended-${sorting.currentSort}`}>
        <Recommended sorting={sorting} />
      </li>
      {sorting.sortOptions.value.map((option) => (
        <SortingOption
          key={`${option.key}-${option.order}`}
          sorting={sorting}
          option={option}
        />
      ))}
    </ul>
  );
}

// Note: Is moved in a separate component to avoid re-rendering the entire drawer.
// We need to consume signals here NOT in a reactive way for this DS Chip.
function Recommended({ sorting }: SortingProps) {
  const { t } = useTranslations<Translations>();
  const recommendedText = t('productList.sort.recommended');

  return (
    <Chip
      aria-label={recommendedText}
      label={recommendedText}
      isActive={!sorting.currentSort.value}
      onClick={() => {
        sorting.clearSort();
      }}
    />
  );
}

// Note: Is moved in a separate component to avoid re-rendering the entire drawer.
// We need to consume signals here NOT in a reactive way for this DS Chip.
function SortingOption({
  sorting,
  option
}: SortingProps & { option: SortOption }) {
  const currentSort = sorting.currentSort.value;
  const isActive =
    currentSort?.key === option.key && currentSort?.order === option.order;

  return (
    <li key={`${option.key}-${option.order}-${isActive}`}>
      <Chip
        aria-label={option.label}
        label={option.label}
        isActive={isActive}
        onClick={() => {
          if (isActive) {
            sorting.clearSort();
          } else {
            sorting.applySort(option.id);
          }
        }}
      />
    </li>
  );
}
